import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography, Button, Box, Grid, Divider, Dialog, useMediaQuery } from "@material-ui/core";
import useIsDesktop from "../hooks/useIsDesktop";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { grey } from "@mui/material/colors";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import defaultimg from "../assets/images/default.png";
import AddItemButton from "../components/AddItemButton";
import VegIcon from "../assets/images/Veg Icon 1.svg";
import NonVegIcon from "../assets/images/Non Veg Icon 1.svg";
import { BUTTON_COLOR, TEXT_COLOR } from "../utils/constant";
import {
  addQuantity,
  subtractQuantity,
} from "../store/actions/cartActions";

// Styled components for the SwipeableDrawer
const drawerBleeding = 20;

const StyledBox = styled("div")(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.applyStyles?.("dark", {
    backgroundColor: grey[800],
  }),
}));

const Puller = styled("div")(({ theme }) => ({
  width: 40,
  height: 4,
  backgroundColor: grey[300],
  borderRadius: 3,
  position: "absolute",
  top: 8,
  left: "calc(50% - 20px)",
  ...theme.applyStyles?.("dark", {
    backgroundColor: grey[900],
  }),
}));

const StyledButton = styled(Button)({
  textTransform: "none",
  boxShadow: "none",
  borderRadius: "8px",
  padding: "10px 16px",
  fontWeight: 600,
});

const CartItem = styled("div")({
  padding: "16px",
  borderBottom: "1px solid #f0f0f0",
});

const Repeatation = function (props) {
  const {
    setModifierPopup,
    isRepeatation,
    setIsRepeatation,
    currency,
    selectedItem,
    setSelectedItem,
    storeInfo,storeInfoConfig,
    action,
  } = props;

  const dispatch = useDispatch();
  const cartProps = useSelector((state) => state.cartReducer);
  const isDesktop = useIsDesktop("(min-width:768px)");

  let primaryColor = storeInfoConfig?.general_config?.primary_color;
  let secondaryColor = storeInfoConfig?.general_config?.secondary_color;

  const [showMoreAddons, setShowMoreAddons] = React.useState({});

  const cartItemAddons = cartProps?.addedItems?.filter(
    (e) => e?._id === selectedItem?._id
  );

  const handleChooseAnother = () => {
    setModifierPopup(true);
    setIsRepeatation(false);
  };

  useEffect(() => {
    if (cartItemAddons.length === 0) {
      setIsRepeatation(false);
    }
  }, [cartItemAddons, setIsRepeatation]);

  const toggleDrawer = (newOpen) => () => {
    if (!newOpen) {
      setIsRepeatation(false);
    }
  };

  const renderContent = (isWebView) => (
    <Box sx={{ overflow: "auto", maxHeight: isWebView ? "calc(90vh - 140px)" : "calc(100% - 50px)", padding: isWebView ? "20px 24px" : "0px" }} className={isWebView ? "custom-dialog-scrollbar" : ""}>
      {isWebView && (
        <style>{`
          .custom-dialog-scrollbar::-webkit-scrollbar {
            width: 6px;
          }
          .custom-dialog-scrollbar::-webkit-scrollbar-track {
            background: #FAFAFA;
            border-radius: 4px;
          }
          .custom-dialog-scrollbar::-webkit-scrollbar-thumb {
            background: ${primaryColor || BUTTON_COLOR || '#eb5c24'}45;
            border-radius: 4px;
          }
          .custom-dialog-scrollbar::-webkit-scrollbar-thumb:hover {
            background: ${primaryColor || BUTTON_COLOR || '#eb5c24'}75;
          }
        `}</style>
      )}
      {/* Customized items list */}
      <Box style={{ padding: "0px" }}>
        {cartItemAddons?.map((item, idx) => {
          const addonNames = [];
          const variantName = item?.item_variant?.[0]?.variant_name;
          if (variantName && variantName.toLowerCase() !== "regular") {
            addonNames.push(variantName);
          }
          if (item?.selected_addons_items?.length) {
            item.selected_addons_items.forEach((addon) => {
              if (addon?.item_name) {
                addonNames.push(addon.item_name);
              }
            });
          }
          const allAddonsText = addonNames.join(", ");
          const maxAddonsLength = 40;
          const isLong = allAddonsText.length > maxAddonsLength;
          const key = `${item._id}-${idx}`;
          const showAll = showMoreAddons[key];
          const addonsText = isLong && !showAll
            ? allAddonsText.slice(0, maxAddonsLength)
            : allAddonsText;

          const toggleShowMore = () => {
            setShowMoreAddons((prev) => ({
              ...prev,
              [key]: !prev[key],
            }));
          };

          return (
            <Grid
              container
              key={item._id}
              style={{
                backgroundColor: "#ffffff",
                padding: "16px",
                marginBottom: isWebView ? "12px" : "0px",
                boxShadow: isWebView ? "0px 1px 3px rgba(0,0,0,0.1)" : "rgba(50, 50, 71, 0.04) 0px 4px 10px",
                border: "1px solid #f0f0f0",
                borderRadius: isWebView ? "8px" : "0px",
              }}
            >
              <Grid container xs={12} style={{ display: "flex", gap: "12px" }}>
                {/* Left: Image with Veg/Non-Veg Icon */}
                <Grid item xs={3} style={{ display: "flex", justifyContent: "flex-start", maxWidth: isWebView ? "90px" : undefined }}>
                  <div style={{ position: "relative", width: isWebView ? "80px" : "70px", height: isWebView ? "75px" : "65px" }}>
                    {selectedItem?.dietary && (
                      <img
                        src={
                          selectedItem?.dietary?.toLowerCase() === "veg"
                            ? VegIcon
                            : selectedItem?.dietary?.toLowerCase() === "non-veg"
                              ? NonVegIcon
                              : ""
                        }
                        alt={selectedItem?.dietary}
                        style={{
                          position: "absolute",
                          top: "4px",
                          left: "4px",
                          width: "14px",
                          height: "14px",
                          objectFit: "contain",
                          zIndex: 2,
                        }}
                      />
                    )}
                    <img
                      alt={item.item_name}
                      style={{ width: "100%", height: "100%", borderRadius: "8px", objectFit: "cover" }}
                      src={selectedItem?.item_display_img || defaultimg}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = defaultimg;
                      }}
                    />
                  </div>
                </Grid>

                {/* Right: Info */}
                <Grid item xs={isWebView ? true : 8} style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                  {/* Name & Quantity Selector */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontFamily: "Satoshi",
                        fontSize: "15px",
                        color: "#333",
                        textAlign: "left",
                      }}
                    >
                      <span style={{ fontSize: "16px" }}>{item?.item_name || "NA"}</span>
                    </Typography>

                    {/* Quantity Selector matching CartItems exactly */}
                    <div
                      style={{
                        display: "flex",
                        padding: "2px 6px",
                        justifyContent: "space-evenly",
                        alignContent: "center",
                        alignItems: "center",
                        minWidth: isWebView ? "70px" : "5.5rem",
                        borderRadius: isWebView ? "4px" : "6px",
                        backgroundColor: primaryColor || BUTTON_COLOR,
                        boxShadow: "none",
                        height: "30px",
                      }}
                    >
                      <Grid container justifyContent="center" alignItems="center" xs={4} sm={4} md={4} lg={4}>
                        <RemoveIcon
                          style={{
                            color: "#ffffff",
                            fontSize: "18px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            dispatch(subtractQuantity(item));
                          }}
                        />
                      </Grid>
                      <Grid xs={4} sm={4} md={4} lg={4} style={{ display: "flex", justifyContent: "center" }}>
                        <Typography>
                          <span
                            style={{
                              fontSize: "14px",
                              fontFamily: "Satoshi",
                              color: "#ffffff",
                              fontWeight: "700",
                            }}
                          >
                            {item?.quantity || 0}
                          </span>
                        </Typography>
                      </Grid>
                      <Grid container justifyContent="center" alignItems="center" xs={4} sm={4} md={4} lg={4}>
                        <AddIcon
                          style={{
                            color: "#ffffff",
                            fontSize: "18px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            dispatch(addQuantity(item));
                          }}
                        />
                      </Grid>
                    </div>
                  </div>

                  {/* Description/Addons */}
                  <div style={{ textAlign: "left", marginTop: "4px", maxWidth: isWebView ? "100%" : "calc(100% - 95px)" }}>
                    {addonsText && (
                      <div style={{ fontFamily: "Satoshi", fontSize: "14px", color: "#999999", lineHeight: "1.3" }}>
                        {addonsText}
                        {isLong && (
                          <span
                            style={{ color: primaryColor || "#2B6CB0", cursor: "pointer", fontWeight: "600", marginLeft: "4px" }}
                            onClick={toggleShowMore}
                          >
                            {showAll ? " less" : "...more"}
                          </span>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Price (formatting integer decimals) */}
                  <div style={{ textAlign: "left", marginTop: "6px" }}>
                    <Typography
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "16px",
                        color: primaryColor || BUTTON_COLOR,
                      }}
                    >
                      {currency}
                      {(parseFloat(item?.sub_total || 0)).toFixed(2)}
                    </Typography>
                  </div>

                  {/* Special Request */}
                  {item?.specialRequest && (
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "8px", 
                      color: "#333",
                      gap: "8px",
                    }}>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ flexShrink: 0 }}
                      >
                        <path
                          d="M13.7682 1.962L12.0116 0.22213C11.8606 0.0795438 11.66 0 11.4513 0C11.2427 0 11.0421 0.0795438 10.8911 0.22213L9.32914 1.7739H0.94953C0.697699 1.7739 0.456182 1.87299 0.278111 2.04936C0.100039 2.22573 0 2.46494 0 2.71437V13.0595C0 13.309 0.100039 13.5482 0.278111 13.7245C0.456182 13.9009 0.697699 14 0.94953 14H11.3944C11.6462 14 11.8877 13.9009 12.0658 13.7245C12.2439 13.5482 12.3439 13.309 12.3439 13.0595V4.48245L13.7682 3.07175C13.9166 2.92451 14 2.72495 14 2.51687C14 2.3088 13.9166 2.10924 13.7682 1.962ZM7.04077 8.41832L5.0515 8.85563L5.52627 6.90416L10.0603 2.40402L11.5938 3.92287L7.04077 8.41832ZM12.1065 3.38681L10.573 1.86795L11.4513 0.998017L12.9848 2.51687L12.1065 3.38681Z"
                          fill={primaryColor || BUTTON_COLOR}
                        />
                      </svg>
                      <span style={{ fontFamily: "Satoshi", fontSize: "14px", fontWeight: "600", color: "#333", wordBreak: "break-word", textAlign: "left", lineHeight: "1.4" }}>
                        {item.specialRequest}
                      </span>
                    </div>
                  )}
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      </Box>
    </Box>
  );

  return (
    <>
      <CssBaseline />
      {isDesktop ? (
        <Dialog
          open={isRepeatation}
          onClose={toggleDrawer(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: "12px",
              margin: "16px",
              maxHeight: "90vh",
            },
          }}
        >
          {/* Header */}
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px 24px",
              borderBottom: "1px solid #EEEEEE",
              backgroundColor: "#ffffff",
            }}
          >
            <Typography variant="h6">
              <span style={{ fontWeight: "700", fontFamily: "Satoshi", fontSize: "20px", color: "#1A1A1A" }}>
                {!action
                  ? "Update customisation?"
                  : `Customisations for ${selectedItem?.item_name}`}
              </span>
            </Typography>
            <CloseIcon
              onClick={() => setIsRepeatation(false)}
              style={{ color: primaryColor || BUTTON_COLOR, cursor: "pointer" }}
            />
          </Box>
          
          {renderContent(true)}

          {/* Footer */}
          {!action && (
            <Box
              sx={{
                p: 2,
                borderTop: "1px solid #EEEEEE",
                bgcolor: "#fff",
              }}
            >
              <StyledButton
                fullWidth
                variant="contained"
                onClick={handleChooseAnother}
                style={{
                  backgroundColor: primaryColor || BUTTON_COLOR,
                  color: "#ffffff",
                  fontSize: "16px",
                  fontWeight: "700",
                  fontFamily: "Satoshi",
                  borderRadius: "4px",
                  padding: "12px 0px",
                  textTransform: "none",
                  boxShadow: "none",
                }}
              >
                Add New Customisation
              </StyledButton>
            </Box>
          )}
        </Dialog>
      ) : (
        <SwipeableDrawer
          anchor="bottom"
          open={isRepeatation}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
          disableSwipeToOpen={true}
          PaperProps={{
            style: {
              borderTopLeftRadius: 24,
              borderTopRightRadius: 24,
              maxHeight: "90%",
              backgroundColor: "rgb(248, 249, 250)",
            },
          }}
        >
          {/* Header */}
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              borderBottom: "1px solid #f0f0f0",
              backgroundColor: "#ffffff",
            }}
          >
            <Typography variant="h6">
              <span style={{ fontWeight: "500", fontFamily: "Satoshi", fontSize: "21px", color: primaryColor || BUTTON_COLOR }}>
                {!action
                  ? "Update customisation?"
                  : `Customisations for ${selectedItem?.item_name}`}
              </span>
            </Typography>
            <CloseIcon
              onClick={() => setIsRepeatation(false)}
              style={{ color: primaryColor || BUTTON_COLOR, cursor: "pointer" }}
            />
          </Box>

          {renderContent(false)}

          {/* Footer */}
          {!action && (
            <Box
              sx={{
                p: 2,
                borderTop: "1px solid #f0f0f0",
                position: "sticky",
                bottom: 0,
                bgcolor: "#fff",
                boxShadow: "0px -2px 10px rgba(0,0,0,0.05)",
              }}
            >
              <StyledButton
                fullWidth
                variant="contained"
                onClick={handleChooseAnother}
                style={{
                  backgroundColor: primaryColor || BUTTON_COLOR,
                  color: "#ffffff",
                  fontSize: "16px",
                  fontWeight: "700",
                  fontFamily: "Satoshi",
                  borderRadius: "10px",
                  padding: "12px 0px",
                  textTransform: "none",
                  boxShadow: "none",
                }}
              >
                Add New Customisation
              </StyledButton>
            </Box>
          )}
        </SwipeableDrawer>
      )}
    </>
  );
};

export default Repeatation;

